import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function Declarative(props) {
    const { t } = useTranslation("translation");
    return props.isMultipleDeclarative ? (
        <Autocomplete
            multiple
            id="bl_table_Autocomplete_3"
            options={props.userData}
            limitTags={5}
            value={props.userData.filter((item) => props.creatorName?.includes(item.id))}
            disableCloseOnSelect
            getOptionLabel={(option) => option.userName}
            onChange={(event, newValue) => {
                props.HandleCreatorName(newValue);
            }}
            renderOption={(_props, option) => <li {..._props}>{option.userName}</li>}
            renderInput={(params) => <TextField id="bl_table_TextField_2" {...params} margin="normal" label={t("Declarative")} variant="outlined" size="small" />}
            size={props.size ?? "normal"}
        />
    ) : (
        <Autocomplete
            id="bl_table_Autocomplete_3"
            onChange={(event, newValue) => {
                props.HandleCreatorName(newValue);
            }}
            value={!props.creatorName || props.creatorName === "null" ? null : props.creatorName}
            defaultValue=""
            options={props.userData.map((option) => option.userName)}
            renderInput={(params) => <TextField id="bl_table_TextField_2" {...params} margin="normal" label={t("Declarative")} variant="outlined" size="small" />}
            size={props.size ?? "normal"}
        />
    );
}
